import type { ReactNode } from 'react';

type LabelVariant = 'primary' | 'danger' | 'warning' | 'success' | 'info';

interface OutlineLabelProps {
    variant: LabelVariant;
    children: ReactNode;
    className?: string;
}

const OutlineLabel = ({ variant, children, className = '' }: OutlineLabelProps) => (
    <span
        className={`label label-${variant} label-condensed ${className}`.trim()}
        style={{ backgroundColor: 'transparent' }}
    >
        {children}
    </span>
);

export default OutlineLabel;
